/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/ProfileEvent.php */
export const profileEvent = {
	Updated: 'updated',
	PrimaryChanged: 'primary-changed',
	Archived: 'archived',
} as const

/** @see backend/nexus/modules/Billing/Broadcasting/Enums/ProfileEvent.php */
export type ProfileEvent = (typeof profileEvent)[keyof typeof profileEvent]
